import { onPageLoad } from "@/lib/on_page_load";
import "@/lib/_jquery";
import { HideByCheckbox, ShowByCheckbox } from "@/lib/helpers/HideByCheckbox";

const checkboxElements = new WeakSet<Element>();
const selectElements = new WeakSet<Element>();
const counterElements = new WeakSet<Element>();
const wysiwygCounterElements = new WeakSet<Element>();
const focusForms = new WeakSet<Element>();

function initializeElement(initializedElements: WeakSet<Element>, element: Element, callback: () => void) {
  if (initializedElements.has(element)) return;

  initializedElements.add(element);
  callback();
}

function initializeUtils() {
  // Hide element depending on checkbox
  document.querySelectorAll<HTMLElement>("[data-hide-by-checkbox]").forEach((element) => {
    initializeElement(checkboxElements, element, () => {
      try {
        new HideByCheckbox(element).connect();
      } catch {
        console.log("Failed to find checkbox for HideByCheckbox")
      }
    });
  });

  document.querySelectorAll<HTMLElement>("[data-show-by-checkbox]").forEach((element) => {
    initializeElement(checkboxElements, element, () => {
      try {
        new ShowByCheckbox(element).connect();
      } catch {
        console.log("Failed to find checkbox for ShowByCheckbox")
      }
    });
  });

  // Hide element depending on select
  $("[data-hide-by-select]").each(function() {
    initializeElement(selectElements, this, () => {
      const $area = $(this);
      const $select = $($(this).data("hide-by-select"));
      const select_value = $(this).data("hide-by-select-value").toString();

      const activate = function() {
        const value = $(this).val();
        $area.toggleClass("d-none", value === select_value);
      };

      $select.change(activate);
      $select.trigger("change");
    });
  });

  document.querySelectorAll("[data-show-by-select]").forEach(element => {
    initializeElement(selectElements, element, () => {
      const showBySelect = (element as HTMLSelectElement).dataset.showBySelect;
      const showBySelectValue = (element as HTMLSelectElement).dataset.showBySelectValue;
      const select: HTMLSelectElement = document.querySelector(showBySelect);

      function listener() {
        (element as HTMLInputElement).disabled = select.value !== showBySelectValue
        return element.classList.toggle("d-none", select.value !== showBySelectValue);
      }

      select.addEventListener("change", listener);
      listener();
    });
  });

  $("[data-bs-toggle='tooltip']").tooltip();


  // Focus first input or first input with error
  $(".fn-slick-form-focus form").each(function() {
    initializeElement(focusForms, this, () => {
      if (window.navigator.userAgent === "playwright") return;
      let focusedElement = $(".is-invalid:input:visible").not(":button").first();
      if (focusedElement.length === 0) {
        focusedElement = $(":input:visible").not(":button").first();
      }

      // Select text on focus
      focusedElement.on("focus", function () {
        // Delay sightly to allow focus to "stick" before selecting.
        setTimeout(function() { focusedElement.select(); }, 50);
      });

      // Focus the first input of form
      focusedElement.focus();
    });
  });

  // This is only needed one place.
  // Don't know how to utilise
  // "fn-slick-form-focus" on election config forms
  // without it jumping to bottom of page.
  $(".stay-top").each(function() {
    $(document).scrollTop(0);
  });
}

function initializeCounters() {
  const counters = $("[id^='counter_']");

  counters.each(function(i, val) {
    initializeElement(counterElements, val, () => {
      const counter = $(`#${val.id}`);
      const identity = counter.data("identity");
      const textArea = $(`${identity}`);
      counter?.text((textArea.val() as string[]).length);
      textArea.on("input", function() {
        counter?.text(($(this).val() as string[]).length);
      });
    });
  });
}

function initializeWysiwygCounters() {
  const wysiwygCounters = [];
  const counters = [];
  $("[id^='richcounter_']").each(function(_i, v) {
    counters.push($(v));
    const textArea = document.getElementById(v.id.substring(12));
    wysiwygCounters.push($(textArea));
  });

  $(wysiwygCounters).each(function(index, val) {
    initializeElement(wysiwygCounterElements, val[0], () => {
      const textarea = val;
      $(textarea).on("tbwinit", function() {
        const editor = val.parent().find(".trumbowyg-editor")[0];
        const counter = counters[index];
        counter?.text(editor.innerText.length);
        const updateCounter = () => counter?.text(editor.innerText.replaceAll("\n", "").length);
        updateCounter();
        $(textarea).on("tbwchange", function() {
          updateCounter();
        });
      });
    });
  });
}

function initializeAll() {
  initializeUtils();
  initializeCounters();
  initializeWysiwygCounters();
}

function disposeTooltips() {
  $("[data-bs-toggle='tooltip']").tooltip("dispose");
}

onPageLoad(initializeAll);
document.addEventListener("turbo:before-cache", disposeTooltips);
